import {
  sendWhatsAppVPS
} from "./whatsappVPS";

function formatAppointmentDate(
  fecha,
  hora
) {

  if (!fecha || !hora) {
    return "";
  }

  const date =
    new Date(
      `${fecha}T${hora}`
    );

  const fechaTexto =
    date.toLocaleDateString(
      "es-MX",
      {
        day: "numeric",
        month: "long",
        year: "numeric"
      }
    );

  const horaTexto =
    date.toLocaleTimeString(
      "es-MX",
      {
        hour: "numeric",
        minute: "2-digit",
        hour12: true
      }
    );

  return `${fechaTexto} a las ${horaTexto.toUpperCase()}`;

}

function renderConfiguredTemplate(clinicData, key, fallback, variables = {}) {
  const template =
    clinicData?.comunicacionCampanas?.templates?.[key] ||
    clinicData?.settings?.communication?.templates?.[key] ||
    fallback;
  const message = template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) =>
    variables[name] == null ? "" : String(variables[name])
  );
  const signature = (
    clinicData?.comunicacionCampanas?.signature ||
    clinicData?.settings?.communication?.signature ||
    ""
  ).trim();
  return signature ? `${message}\n\n${signature}` : message;
}

export const sendWhatsAppMessage =
async (

  clinicData,

  patient,

  type,

  data = {}

) => {

  try {

    if (
      !clinicData?.whatsappEnabled
    ) {

      throw new Error(
        "WhatsApp desactivado"
      );

    }

    const whatsappNumber =
      patient?.whatsapp ||
      patient?.telefono;

    if (!whatsappNumber) {

      throw new Error(
        "Paciente sin WhatsApp"
      );

    }

    let message = "";

    switch(type) {

      case "appointment_created":

        message = renderConfiguredTemplate(
          clinicData,
          "appointmentConfirmation",
          `Hola ${patient.nombre}.\n\nHemos registrado tu cita para el día ${formatAppointmentDate(data.fecha, data.hora)} en ${clinicData.nombreClinica}.\n\nGracias por elegirnos.`,
          {
            paciente: patient.nombre,
            fecha: data.fecha,
            hora: data.hora,
            consultorio: clinicData.nombreClinica
          }
        );

        break;

      case "appointment_confirmed":

        message = renderConfiguredTemplate(
          clinicData,
          "appointmentConfirmation",
          `Hola ${patient.nombre}.\n\nTu cita ha sido confirmada.\n\nTe esperamos en ${clinicData.nombreClinica}.`,
          {
            paciente: patient.nombre,
            consultorio: clinicData.nombreClinica
          }
        );

        break;

      case "appointment_cancelled":

        message =

`Hola ${patient.nombre}.

Tu cita ha sido cancelada.

Si deseas reagendar, contáctanos.`;

        break;

      case "appointment_reminder":

        message = renderConfiguredTemplate(
          clinicData,
          "appointmentReminder",
          `Hola ${patient.nombre}.\n\nTe recordamos que tienes una cita programada mañana en ${clinicData.nombreClinica}.\n\nResponde únicamente con el número de la opción que desees:\n\n1. Confirmar cita\n2. Reagendar cita\n\nSi eliges 2, te pediremos la nueva fecha y te mostraremos los horarios disponibles.`,
          {
            paciente: patient.nombre,
            consultorio: clinicData.nombreClinica,
            fecha: data.fecha,
            hora: data.hora
          }
        );

        break;

      case "prescription":

        message =

`Hola ${patient.nombre}.

Tu receta ya está disponible.

Gracias por confiar en nosotros.`;

        break;

      default:

        message =
          data.message || "";

    }

    const patientName = `${patient?.nombre || ""} ${patient?.apellidos || ""}`.trim() ||
      patient?.nombreCompleto || data.patientName || null;

    return await sendWhatsAppVPS(
      clinicData.id,
      whatsappNumber,
      message,
      patient?.id || data.patientId || null,
      patientName
    );

  } catch(err) {

    console.error(err);

    return {

      success: false,

      error: err.message

    };

  }

};
